"use client";

import React from "react";
import { StyledDiv } from "./trustedBy.styles";
import { CommonNinjaWidgetRenderer } from '../CommonNinjaWidgetRenderer/commonNinjaWidgetRenderer.comp';
import classNames from "classnames";
import { CSSProperties } from "styled-components";

export const TrustedBy = ({ mode = 'light', style }: { mode?: 'light' | 'dark'; style?: CSSProperties }) => {
  return (  
    <StyledDiv className={classNames(mode)} style={style}>
      <h3>Trusted by</h3>
      <CommonNinjaWidgetRenderer widgetId="9dead464-d1a6-4537-9c2c-41629ed375dc" />
    </StyledDiv>
  );
};
